<template>
  <w-main-template>
    <!-- side -->
    <!-- <div @click="hideSearchPopup"> -->
    <w-log-tree slot="sideContent" ref="logTree" :search-tags="searchTags" />
    <!-- </div> -->
    <!-- title -->
    <w-main-title slot="mainTitle" :title="selectedNode.label">
      <div slot="rightTool" class="vertical-center-box">
        <el-button class="mr-r4" type="solid" v-if="userInfo.managerType === 'ADMIN'" @click="openLogStorePopup">저장소 구성</el-button>
        <w-datetime-range-button ref="datepicker" v-show="activeTabName !== 'event'" :disabled="activeTabName === 'search'"/>
      </div>
    </w-main-title>
    <!-- main -->
    <div slot="mainContent" class="page-container-content tabgroup">
      <w-tool-tabs v-model="activeTabName" @tab-click="hideSearchPopup">
        <el-tab-pane :label="tabs.search.label" :name="tabs.search.name" class="h100 w100">
          <div class="full-wrapper" @click="hideSearchPopup">
            <w-search :active="tabs.search.active" @change-search-tags="changeSearchTags"></w-search>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="tabs.analysis.label" :name="tabs.analysis.name" class="h100 w100">
          <div class="full-wrapper" @click="hideSearchPopup">
            <w-analysis :active="tabs.analysis.active" @change-search-tags="changeSearchTags"></w-analysis>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="tabs['keyword-map'].label" :name="tabs['keyword-map'].name" class="h100 w100">
          <div class="full-wrapper">
            <w-keyword-map :active="tabs['keyword-map'].active"/>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="tabs.event.label" :name="tabs.event.name" class="h100 w100">
          <div class="full-wrapper">
            <w-event :active="tabs.event.active"></w-event>
          </div>
        </el-tab-pane>
        <w-log-store ref="logStorePopup"></w-log-store>
      </w-tool-tabs>
    </div>
  </w-main-template>
</template>

<script>
import { mapGetters } from 'vuex';
import RouterTab from '@/mixins/router/tab';

import WMainTemplate from '@/components/template/MainTemplate';
import WMainTitle from '@/components/template/MainTitle';
import WDatetimeRangeButton from '@/components/button/DatetimeRangeButton';
import WEventlevelCell from '@/components/table/EventlevelCell';

import WLogTree from './components/LogTree';
import WSearch from './RealtimeSearch';
import WAnalysis from './Analysis';
import WKeywordMap from './KeywordMap';
import WEvent from './Event';
import WLogStore from './popup/store';

export default {
  name: 'WLog',
  mixins: [RouterTab],
  components: {
    WMainTemplate,
    WMainTitle,
    WDatetimeRangeButton,
    WEventlevelCell,
    WLogTree,
    WSearch,
    WAnalysis,
    WKeywordMap,
    WEvent,
    WLogStore,
  },
  data() {
    const logAnalysisTabs = {
      search: {
        name: 'search',
        label: '실시간',
        active: false,
        default: true,
      },
      analysis: {
        name: 'analysis',
        label: '분석',
        active: false,
      },
      event: {
        name: 'event',
        label: '알람',
        active: false,
      },
      'keyword-map': {
        name: 'keyword-map',
        label: '키워드맵',
        active: false,
      },
    };
    return {
      /**
       * 헤더 검색 기능 제공 여부
       * @type {Boolean}
       */
      showSearchTool: false,
      showSearchPopover: false,
      searchTags: [],
      logChartDatas: [],
      wordCount: [],
      tabs: logAnalysisTabs,
      commonField: [],
    };
  },
  computed: mapGetters(['analysisDateParams', 'userInfo', 'selectedNode']),
  watch: {
    activeTabName(value) {
      if (value === 'search') {
        this.$store.dispatch('setInitialDatetimeRange', { type: 'fixed', value: 'today', label: '오늘' });
      }
    },
  },
  created() {
    this.$store.dispatch('setInitialDatetimeRange', { type: 'fixed', value: 'today', label: '오늘' });
  },
  methods: {
    setWordCount(item) {
      this.wordCount = item;
    },
    /**
     * 헤더 검색 기능을 토글한다.
     * @author Ju
     * @return {[type]} [description]
     */
    onClickSetSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    hideSearchPopup() {
      this.showSearchPopover = true;
    },
    changePopoverShow(isShow) {
      this.showSearchPopover = isShow;
    },
    changeTreeData() {
      this.$refs.logTree.loadCustomFilterData();
    },
    initData() {
      this.changeTreeData();
    },

    // FIXME LMS 프로토타입
    openLogStorePopup() {
      this.$refs.logStorePopup.open();
    },
    changeSearchTags(value) {
      this.searchTags = value;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/log-analysis/index.vue